// Файловые web-хелперы. Перенесено из src/features/edo/processUI.tsx (было импортом ЭДО-модуля
// для несвязанных экранов вроде news.tsx/profile.tsx).
import { Platform } from 'react-native'

/** Web-only file picker (в проекте нет native document-picker) → File | null. */
export function pickFileWeb(accept: string): Promise<File | null> {
  return new Promise((resolve) => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return resolve(null)
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.onchange = () => resolve(input.files?.[0] ?? null)
    input.click()
  })
}

/** То же, но несколько файлов за раз (`<input multiple>`) → File[] (пусто — ничего не выбрали). */
export function pickFilesWeb(accept: string): Promise<File[]> {
  return new Promise((resolve) => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return resolve([])
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.multiple = true
    input.onchange = () => resolve(Array.from(input.files ?? []))
    input.click()
  })
}

/**
 * Скачать защищённый файл (нужен `Authorization`, поэтому простым `<a href>` его не взять).
 * Тянем с токеном, получаем blob и отдаём браузеру как загрузку.
 *
 * Web-only — по той же причине, что и пикер выше: нативного файлового слоя в проекте нет.
 * ponytail: апгрейд — подписанная ссылка на вложение, как у 1С (`/edo/attachments/:id/link`):
 * тогда файл откроется и на телефоне, и без токена в заголовке.
 */
export async function downloadWithAuth(
  fetchBlob: () => Promise<Blob>,
  fileName: string,
): Promise<void> {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return
  const blob = await fetchBlob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  // Освобождаем объектный URL — иначе blob живёт до перезагрузки страницы.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
